module.exports = require('./helpers/bundle-url').getBundleURL('cWze5') + "logo-dark.eefe0b7f.svg";